// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__aD-X3","loaderOuter":"PageOverlayLoader_loaderOuter__AiGSX"};